/**
 * Central React Query keys for organization-related caches.
 * Prefer these over ad-hoc string arrays so invalidate/set stay consistent.
 */
export const organizationKeys = {
  lists: ['organizations'] as const,
  effectiveAll: ['effectiveOrganization'] as const,
  effective: (organizationName: string | null) =>
    [...organizationKeys.effectiveAll, organizationName] as const,
};

/** Default Organization header for LDT CS/Sales (present in all LDT environments). */
export const LDT_DEFAULT_ORGANIZATION_NAME = 'artera';
